module.exports = __webpack_public_path__ + "img/th.c6f2dbe0.svg";